export function times<T>(amount: number, iter: (idx: number) => T): T[] {
	const res: T[] = []

	for (let i = 0; i < amount; i++) {
		res.push(iter(i))
	}

	return res
}
